import RestResource from '../rest.service';
export default class ProvincesService extends RestResource {
  constructor(api) {
    super(api, 'provinces', 'api');
  }
}
